<template lang="html">

	<section class="mantenimiento row-center" :style="`background:url(${background}) center/cover no-repeat`">
		
		<div class="popup column-center">
			<img :src="logo" class="logo">
			 <h2 class="title">Portal temporalmente sin servicio</h2>
       		<p >Estaremos en labores de mantenimiento hasta el próximo lunes 11 de noviembre, para cualquier duda puede contactar en <u ><a  href="mailto:c.profesionales@ufv.es">c.profesionales@ufv.es</a></u> <br >Rogamos disculpe las molestias.
            </p>
		</div>

	</section>

</template>

<script lang="js">

	import {mapGetters,mapActions} from 'vuex';

	export default  {
		name: 'mantenimiento',
		computed:{
			...mapGetters({
				background : 'getBackground',
				logo : 'getLogoColor',
			})
		}

	}
</script>

<style scoped lang="scss">
	.mantenimiento{
		width: 100%;
		min-height: 100vh;
		padding: 20px;
	}

	.popup{
		width: 700px;
		padding: 50px;
		background: white;

		.logo{
			max-width: 200px;
			margin-bottom: 30px;
			display: inline-block;
		}

		h2{
			width: 100%;
			display: inline-block;
			margin-bottom: 10px;
			font-weight: bold;
			font-size: 30px;
		}
	}

	@media screen and (max-width: 768px){
		.popup h2{
			font-size: 16px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/views/mantenimiento.vue